module.exports = __webpack_public_path__ + "static/media/Pitbull.6af8bdbc.mp3";